// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--d6b347"};